import React from 'react';
import {stepCompletionResultType} from "../../../types/Api/StepResultType";
import {useForm} from "react-hook-form";
import {Require} from "../Require";
import {ApiService} from "../../../service/ApiService";

type FormDataType = {
  label?: string;
}

export type StepEditProps = {
  step: stepCompletionResultType;
  close: (c: boolean) => void;
}

export const StepEdit = ({step, close}: StepEditProps) => {
  const {
    register,
    handleSubmit,
    formState: {errors}
  } = useForm<FormDataType>({
    defaultValues: {
      label: step.label,
    }
  });

  const onSubmit = async (data: FormDataType) => {
    const d = {
      label: data.label,
      stepId: step.step_id,
      oldLabel: step.label,
    };

    await ApiService.patch(`/step/completion`, { param: () => d })
    close(true);
  }

  return (
    <>
      <div className="__modal_container__ d-flex justify-content-center align-items-center">
        <div className="__modal_background__"/>
        <div className="__modal_box__ __front_box__ w500px max-w70 max-h80">
          <div>
            <h2 className="__front_info_title__ m-0">Modifier l'étape</h2>
            <hr className="w-50 ms-auto me-auto mt-3 mb-4"/>
          </div>

          <form method="post" onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-3">
              <label className="form-label" htmlFor="form-label">Label <Require/></label>
              <input id="form-label" type="text" className="form-control" placeholder="~" {...register("label", {
                required: "Le label est requis",
                validate: {
                  minLength: (value) =>
                    (value ?? "").length <= 255 || "Le label ne doit pas dépasser 255 caractères",
                },
              })}
              />
              {errors.label && <p className="text-danger">{errors.label.message}</p>}
            </div>

            <p className="m-0 mt-5 text-end">
              <button className="btn btn-sm btn-success me-1" type="submit">Enregistrer</button>
              <button className="btn btn-sm btn-info" onClick={() => close(false)}>Annuler</button>
            </p>

          </form>
        </div>
      </div>
    </>
  );
}
